import lazyLoad from '@helper/lazy-load'

const router = [
    {
        path: '/app/customer',
        element: lazyLoad(() => import('@pages/customer/components/main')),
        loader: () => ({ menuIndex: 1, key: 'customer.customer', icon: 'icon-pengyou', show: true }),
        children: [
            {
                index: true,
                element: lazyLoad(() => import('@pages/customer-list/components/main')),
                loader: () => ({ key: 'customer.list', activeMenu: '/app/customer' })
            },
            {
                path: '/app/customer/:customerId',
                element: lazyLoad(() => import('@pages/customer-detail/components/main')),
                loader:() => ({ key: 'customer.detail', activeMenu: '/app/customer', show: true })
            }
        ]
    }
]

export default router
